import { createApiInstance } from "./apiClient";

const productUrl = process.env.REACT_APP_PRODUCT_API_URL;

export const getProductCategoriesAndTypes = async () => {
  try {
    const instance = createApiInstance({ baseURL: `${productUrl}/api/staticdata`, retry: true });

    const requestUrl = `/categories-and-types`;

    return await instance
      .get(requestUrl)
      .then((response) => {
        if (response.status === 200)
          return {
            error: false,
            success: true,
            message: response.data.message,
            data: response.data.data,
          };
        else
          return {
            error: true,
            success: false,
            message: response.data.message,
          };
      })
      .catch((error) => {
        if (error.response) {
          console.error("Server Error:", error.response.status);
        } else if (error.request) {
          console.error("Network Error:", error.request);
        } else {
          console.error("Error:", error.message);
        }
        return {
          error: true,
          success: false,
          message: "Something went wrong. Please try again.",
        };
      });
  } catch (e) {
    return {
      error: true,
      success: false,
      message: "Something went wrong. Please try again.",
    };
  }
};
